Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.Filters.SubTypeTranslations

  constructor: ->
    @translations = {
      "gp_review_comment": "Google Play review comment",
      "ig-message": "Ig Direct",
      "instagram_business_discovery_listening_media": "Listening Media",
      'google-my-business-review': 'Review',
      'google-my-business-reply': 'Reply'
    }

  getTranslation: (name) ->
    return @translations[name] if @translations[name]?
    name
